import { Checkbox, CheckboxProps, FormControl, FormControlLabel } from "@mui/material";
import { Controller } from "react-hook-form";
import ErrorSharp from "@mui/icons-material/ErrorSharp";
import * as S from "./styles";
import { isEmpty } from "@/main/services/utils";
import RenderTooltipMessage from "../renderTooltipMessage/renderTooltipMessage";

interface ICheckBoxProps extends CheckboxProps {
	label: string;
	control: any;
	nameCustom: string;
	removeMargin?: boolean;
	tooltipMessage?: string;
	tooltipOnControlOnly?: boolean;
	hasErrorCustom?: boolean;
	errorMessageCustom?: string;
	required?: boolean; //it's used to show the asterisk in the label
	onChangeCustom?: (value: boolean) => void;
}

function KogCheckBoxControlled({
	label,
	control,
	nameCustom,
	hasErrorCustom,
	errorMessageCustom,
	removeMargin = false,
	required = false,
	tooltipMessage,
	tooltipOnControlOnly = false,
	onChangeCustom = () => {},
	...props
}: ICheckBoxProps) {
	return (
		<Controller
			name={nameCustom}
			control={control}
			render={({ field }) => (
				<RenderTooltipMessage tooltipMessage={tooltipOnControlOnly ? undefined : tooltipMessage}>
					<S.Container
						$haveError={!!hasErrorCustom}
						title={isEmpty(tooltipMessage) ? label : undefined}
						$removeMargin={removeMargin}
					>
						<FormControl error={!!hasErrorCustom}>
							<RenderTooltipMessage
								tooltipMessage={tooltipOnControlOnly ? tooltipMessage : undefined}
								isAnchoredToChild
							>
								<FormControlLabel
									label={
										<>
											{label}
											{required && <span style={{ color: "red", marginLeft: "2px" }}>*</span>}
										</>
									}
									control={
										<Checkbox
											inputRef={field.ref}
											checked={!!field.value}
											onChange={(e: any) => {
												field.onChange(e.target.checked);
												onChangeCustom(e.target.checked);
											}}
											onBlur={field.onBlur}
											inputProps={{ "aria-label": "controlled" }}
											{...props}
										/>
									}
								/>
							</RenderTooltipMessage>
							{!!hasErrorCustom && (
								<S.AreaError>
									<ErrorSharp style={{ color: "red" }} />
									<p>{errorMessageCustom}</p>
								</S.AreaError>
							)}
						</FormControl>
					</S.Container>
				</RenderTooltipMessage>
			)}
		/>
	);
}

export default KogCheckBoxControlled;
